export const JOIN_SECTION_I18N = {
  message: {
    createUserFailed: $localize`:@@pages.joinSection.message.createUserFailed:ユーザアカウントの作成に失敗しました。`,
    sectionAccess: (sectionName: string) => $localize`:@@pages.joinSection.message.sectionAccess:セクション ${sectionName}:SECTION_NAME: にアクセス可能になりました`,
    sectionGroupAdminAccess: $localize`:@@pages.joinSection.message.sectionGroupAdminAccess:セクショングループ管理者としてアクセス可能になりました`,
    systemAdminAccess: $localize`:@@pages.joinSection.message.systemAdminAccess:システム管理者としてアクセス可能になりました`,
    addPermissionFailed: $localize`:@@pages.joinSection.message.addPermissionFailed:ユーザアカウントの権限追加に失敗しました。`,
    linkInvalid: $localize`:@@pages.joinSection.message.linkInvalid:この招待リンクはすでに無効になっています`,
    linkExpired: $localize`:@@pages.joinSection.message.linkExpired:この招待リンクは有効期限が過ぎています`,
    linkCanceled: $localize`:@@pages.joinSection.message.linkCanceled:この招待リンクは招待者によってキャンセルされました`,
    userIdAlreadyTaken: $localize`:@@pages.joinSection.message.userIdAlreadyTaken:このユーザIDは既に使用されています。\n別のユーザIDを入力してください。`,
    alreadyBelongs: (sectionName: string) => $localize`:@@pages.joinSection.message.alreadyBelongs:このユーザは既にセクション「${sectionName}:SECTION_NAME:」に所属しています。`,
  },
  dialog: {
    titleWarning: $localize`:@@pages.joinSection.dialog.titleWarning:注意`,
    titleJoinComplete: $localize`:@@pages.joinSection.dialog.titleJoinComplete:セクション参加完了`,
  },
  button: {
    close: $localize`:@@pages.joinSection.button.close:閉じる`,
    ok: $localize`:@@pages.joinSection.button.ok:OK`,
  },
} as const;
